import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

const HomeBanner = () => {
  const { t, i18n } = useTranslation();
  const extraBackgroundImage = "/home-banner-extra.png";
  const isArabic = i18n.language?.startsWith("ar");
  const taglineLines = String(t("homeBanner.tagline"))
    .split("\n")
    .filter(Boolean);

  return (
    <Box
      sx={{
        backgroundImage:
          "linear-gradient(180deg, rgba(0,0,0,.65), rgba(0,0,0,.65)),url('/home-heidelberg-bg.png')",
        backgroundSize: "cover",
        backgroundPosition: {
          xs: "38% 9%",
          sm: "42% 9%",
          md: "center 9%",
        },
        color: "white",
        py: { xs: 3, sm: 4, md: 5 },
        position: "relative",
        overflow: "hidden",
        direction: i18n.dir(),
        textAlign: "center",
        minHeight: {
          xs: "290px",
          sm: "340px",
          md: "400px",
          lg: "500px",
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          px: { xs: 2, sm: 4, md: 8 },
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          direction: "ltr",
          height: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: { xs: "4%", sm: "5%", md: "6%" },
            bottom: { xs: 18, sm: 22, md: 22 },
            width: {
              xs: "min(58vw, 240px)",
              sm: "min(48vw, 340px)",
              md: "min(42vw, 560px)",
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0,
            pointerEvents: "none",
            zIndex: 1,
          }}
        >
          <Box
            component="img"
            src={extraBackgroundImage}
            alt=""
            aria-hidden="true"
            sx={{
              display: "block",
              width: "100%",
              height: "auto",
              opacity: 0.92,
              objectFit: "contain",
              mb: { xs: -4, sm: -7, md: -15.5 },
            }}
          />
          <Box
            sx={{
              color: "#fff",
              width: {
                xs: isArabic ? "min(76vw, 300px)" : "min(68vw, 280px)",
                sm: isArabic ? "min(66vw, 420px)" : "min(56vw, 380px)",
                md: "100%",
              },
              textAlign: "center",
              direction: isArabic ? "rtl" : "ltr",
              fontWeight: 800,
              fontSize: {
                xs: isArabic ? "0.68rem" : "0.66rem",
                sm: isArabic ? "0.96rem" : "0.9rem",
                md: isArabic ? "1.34rem" : "1.28rem",
              },
              lineHeight: { xs: 1.24, sm: isArabic ? 1.28 : 1.35 },
              whiteSpace: "normal",
              overflowWrap: "normal",
              wordBreak: "keep-all",
              textShadow: "0 3px 16px rgba(0,0,0,0.7)",
              transform: {
                xs: isArabic ? "translate(12px, -58px)" : "translate(8px, -60px)",
                sm: isArabic ? "translate(34px, -48px)" : "translate(28px, -48px)",
                md: isArabic ? "translate(36px, -95px)" : "translate(56px, -95px)",
              },
            }}
          >
            {taglineLines.map((line) => (
              <Box
                key={line}
                component="span"
                sx={{
                  display: "block",
                  whiteSpace: "nowrap",
                }}
              >
                {line}
              </Box>
            ))}
          </Box>
        </Box>
        <Box
          component="img"
          src="/germany-map-flag.png"
          alt="Germany"
          sx={{
            display: "block",
            width: { xs: 110, sm: 155, md: 230, lg: 280 },
            maxWidth: "45vw",
            height: "auto",
            ml: { xs: 4, sm: 12, md: 34, lg: 54 },
            mt: { xs: 8, sm: 8, md: 0 },
            objectFit: "contain",
            filter: "drop-shadow(0 18px 28px rgba(0,0,0,0.3))",
          }}
        />
      </Container>
    </Box>
  );
};

export default HomeBanner;
